import React from "react";
import { useState, useEffect } from "react";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import { useDispatch, useSelector } from "react-redux";
import {
  changeType,
  changeYear,
  getRevenuData,
  getMatrixDropValue,
} from "../Dashboard/Revenue/RevenueSlice";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
  sessionUser,
} from "../../Util/common";
import {
  getCountOnLeadBarData,
  getCountOnLeadCardsData,
} from "../Dashboard/CountsOnLead/CountonLeadSlice";
import {
  getRingCentralBarData,
  getRingCentralCardData,
} from "../Dashboard/RingCentral/RingCentralSlice";
import {
  getCountsOnLeadReportData,
  getUserFilterReportData,
  Reset,
  UrlForCallLog,
  UrlForCOL,
  UrlForCS,
  UrlForSMS,
} from "./ReportSlice";
import { ReportMatrix } from "./ReportMatrix";
import { baseURL, post } from "../../Util/axios_helper";
import { RefreshKendoGrid } from "../../Kendo/kendo_grid";
const ReportDropdown = ({ CountsOnLeadReport, IsCountsfilter, IsReport }) => {
  const [calendarValue, setCalendarValue] = useState(0);
  const [MatrixValue, setMatrixvalue] = useState();
  const [revenueWeek, setrevenueWeek] = useState([]);
  const [isRevenueMonth, setIsRevenueMonth] = useState(false);
  const [isRevenueQuarter, setIsRevenueQuarter] = useState(false);
  const [isRevenueWeek, setIsRevenueWeek] = useState(false);
  const [isRevenueDay, setIsRevenueDay] = useState(false);
  const [isBallroom, setBallroom] = useState(true);
  const [isCulture, setCulture] = useState(false);
  const [Geo, setGeo] = useState(false);
  const [ReferralType, setReferralType] = useState(false);
  const [sales, setSales] = useState(false);
  const [selectedReport, setSelectedReport] = useState();
  const [selectedReview, setselectedReview] = useState();
  const [selectedCallLog, setselectedCallLog] = useState();
  const [ShowReview, setShowReview] = useState(false);
  const [ShowCallLog, setShowCallLog] = useState(false);
  const [CountsOnLead, setCountsOnLead] = useState(true);
  const [RingCentral, setRingCentral] = useState(true);
  const [selectedReportName, setSelectedReportName] = useState();
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("0");
  const [selectedQuarter, setSelectedQuarter] = useState("0");
  const [selectedWeek, setSelectedWeek] = useState(0);
  const [selectedDate, setSelectedDate] = useState();
  const [data, setData] = useState([]);
  const [error, setError] = useState({});
  const [mb, setmb] = useState({});

  const updatemb = (v) => {
    setmb(v);
  };

  const dispatch = useDispatch();
  const { revenueDataLoaded, MatrixDropVal, MatrixDropLoaded } = useSelector(
    (state) => state.revenue
  );

  const { cardDataLoaded } = useSelector((state) => state.countonLead);
  const { matrixBallroom } = useSelector((state) => state.reportData);
  const { RingCentralcardDataLoaded, RingCentralbarDataLoaded } = useSelector(
    (state) => state.ringcentral
  );
  const shouldnotShowRevenueMatrix =
    (isBallroom || isCulture || ReferralType || sales) &&
    (CountsOnLead || RingCentral);

  const getDropdownvalue = () => {
    dispatch(getMatrixDropValue());
  };
  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear().toString();
    setSelectedYear(currentYear);
    if (IsCountsfilter) {
      dispatch(
        getUserFilterReportData({
          UserId: sessionUser(),
        })
      );
    }

    getDropdownvalue();
  }, []);
  useEffect(() => {
    setmb(matrixBallroom);
  }, [matrixBallroom]);

  useEffect(() => {
    if (
      MatrixDropVal &&
      MatrixDropVal != undefined &&
      MatrixDropVal.Table0Records != undefined &&
      MatrixDropVal.Table1Records != undefined &&
      MatrixDropVal.Table2Records != undefined &&
      MatrixDropVal.Table3Records != undefined
    ) {
      if (isBallroom) {
        setData(MatrixDropVal?.Table0Records);
      }
      if (isCulture) {
        setData(MatrixDropVal?.Table1Records);
      }
      if (ReferralType) {
        setData(MatrixDropVal?.Table2Records);
      }
      if (sales) {
        setData(MatrixDropVal?.Table3Records);
      }
    }
  }, [MatrixDropVal]);
  if (
    !revenueDataLoaded &&
    !cardDataLoaded &&
    !MatrixDropLoaded &&
    !RingCentralcardDataLoaded &&
    !RingCentralbarDataLoaded
  )
    return <Loader />;

  const revenueCalendar = [
    { id: 1, value: "Month" },
    { id: 2, value: "Quarterly" },
    { id: 3, value: "Week" },
    { id: 4, value: "Day" },
  ];

  const ReportList = [
    { id: 0, value: "Revenue" },
    { id: 1, value: "Sales" },
    { id: 2, value: "Counts On Lead Status" },
    { id: 3, value: "Customer Satisfaction" },
    { id: 4, value: "RingCentral SmsLog" },
    { id: 5, value: "RingCentral CallLog" },
  ];

  const ReviewType = [
    { id: "Formal", value: "Formal Review" },
    { id: "General", value: "General Review" },
    { id: "Google", value: "Google Review" },
    { id: "App", value: "App Review" },
  ];

  const CallLogType = [
    { id: "Accepted", value: "Accepted" },
    { id: "Call Connected,Hang Up", value: "Call Connected" },
    { id: "Missed", value: "Missed" },
    { id: "VoiceMail", value: "VoiceMail" },
    { id: "Inbound", value: "Inbound" },
    { id: "Outbound", value: "Outbound" },
  ];

  const CountsOnLeadsFilters = [
    { id: "TC Sent,CC Sent", value: "TC/CC Sent" },
    { id: "Guaranteed", value: "Guaranteed" },
    { id: "R Mail sent - Automated,R email sent Tour Not Booked", value: "R Mail sent" },
    { id: "Tour Booked", value: "Tour Booked" },
    { id: "Tour Done", value: "Tour Done" },
    { id: "Tour Booked but No Show", value: "No Show" },
    { id: "Closed", value: "Closed" },
    { id: "Date N/A", value: "Date N/A" },
    { id: "Spoken to client - Tour N/B", value: "Spoken to client - Tour N/B" }
  ]

  const revenueCalendarOnChange = (e) => {
    const convertToInteger = parseInt(e);
    setCalendarValue(convertToInteger);
    switch (convertToInteger) {
      case 0:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(false);
        setIsRevenueDay(false);
        break;
      case 1:
        setIsRevenueMonth(true);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(false);
        setIsRevenueDay(false);

        break;
      case 2:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(true);
        setIsRevenueWeek(false);
        setIsRevenueDay(false);

        break;
      case 3:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(true);
        setIsRevenueDay(false);

        break;
      case 4:
        setIsRevenueMonth(false);
        setIsRevenueQuarter(false);
        setIsRevenueWeek(false);
        setIsRevenueDay(true);

        break;

      default:
        break;
    }
    if (convertToInteger === 3 && revenueWeek.length === 0) {
      const weeksInYear = 52;
      const newWeeks = Array.from({ length: weeksInYear }, (_, index) => ({
        id: index + 1,
        text: "Week " + (index + 1),
      }));
      newWeeks.unshift({ id: 0, text: "All" });
      setrevenueWeek([...newWeeks]);
    }
  };

  const currentYear = new Date().getFullYear();
  const startYear = 2014;
  const numberOfYears = currentYear - startYear + 1;

  const revenueYear = Array.from({ length: numberOfYears }, (_, index) => {
    const year = currentYear - index;
    return {
      id: year.toString(),
      text:
        IsReport && index === 0
          ? "Current Year"
          : IsReport && index === 1
          ? "Last Year"
          : year,
    };
  });

  const months = [
    { id: "0", text: "All" },
    { id: "01", text: "January" },
    { id: "02", text: "February" },
    { id: "03", text: "March" },
    { id: "04", text: "April" },
    { id: "05", text: "May" },
    { id: "06", text: "June" },
    { id: "07", text: "July" },
    { id: "08", text: "August" },
    { id: "09", text: "September" },
    { id: "10", text: "October" },
    { id: "11", text: "November" },
    { id: "12", text: "December" },
  ];
  const Quarterly = [
    { id: "0", text: "All" },
    { id: "1", text: "1st Quarterly" },
    { id: "2", text: "2nd Quarterly" },
    { id: "3", text: "3rd Quarterly" },
    { id: "4", text: "4th Quarterly" },
  ];
  const Matrix = [
    { matrixId: 1, matrixValue: "Ballrooms" },
    { matrixId: 2, matrixValue: "Culture" },
    { matrixId: 3, matrixValue: "Geo" },
    { matrixId: 4, matrixValue: "Referral Type" },
    { matrixId: 5, matrixValue: "Sales Person / Event Specailist" },
  ];
  const matrixOnChange = (e) => {
    let Indexparsingvalue = parseInt(e);
    setMatrixvalue(Indexparsingvalue);
    switch (Indexparsingvalue) {
      case 1:
        setBallroom(true);
        setCulture(false);
        setGeo(false);
        setReferralType(false);
        setSales(false);

        break;
      case 2:
        setBallroom(false);
        setCulture(true);
        setGeo(false);
        setReferralType(false);
        setSales(false);

        break;
      case 3:
        setBallroom(false);
        setCulture(false);
        setGeo(true);
        setReferralType(false);
        setSales(false);

        break;
      case 4:
        setBallroom(false);
        setCulture(false);
        setGeo(false);
        setReferralType(true);
        setSales(false);

        break;
      case 5:
        setBallroom(false);
        setCulture(false);
        setGeo(false);
        setReferralType(false);
        setSales(true);
        break;
      default:
        break;
    }
    getDropdownvalue();
  };

  const ReportOnChage = (e) => {
    $("#btn-reset").click();
    setSelectedReport(e);
    if (e == 0 || e == 1 || e == 3) {
      setCountsOnLead(false);
      setRingCentral(false);
    } else if (e == 2 || e == 4 || e == 5) {
      setCountsOnLead(true);
      setRingCentral(true);
    }

    if (e == 3) {
      setShowReview(true);
    } else {
      setShowReview(false);
    }

    if (e == 5) {
      setShowCallLog(true);
    } else {
      setShowCallLog(false);
    }

    const selectedItem = ReportList.find((x) => x.id == e);
    if (selectedItem) {
      const selectedText = selectedItem.value;
      setSelectedReportName(selectedText);
    }
  };

  const ReviewOnChage = (e) => {
    setselectedReview(e);
  };

  const CallLogOnChage = (e) => {
    setselectedCallLog(e);
  };

  const revenueYearOnChage = (e) => {
    const splityear = e.split(",");
    setSelectedYear(splityear);
    dispatch(changeYear(e));
  };

  const typeOnChange = (e, type) => {
    let numString = e;
    let numArray = numString.split(",");
    numArray =
      numArray.length > 1 ? numArray.filter((num) => num !== "0") : numArray;
    e = numArray.join(",");
    let spliType = e.split(",");
    if (type === "Month") {
      setSelectedMonth(spliType);
    } else if (type === "Quarterly") {
      setSelectedQuarter(spliType);
    }else if (type === "Week") {
      setSelectedWeek(spliType);
    } 
  };

  const handleSaveClick = async (e) => {
    e.preventDefault();
    $("#save-Filter").modal("show");
  };

  const handleResetClick = (e) => {
    e.preventDefault();
    setCalendarValue(0);
    setMatrixvalue("");
    setrevenueWeek([]);
    setIsRevenueMonth(false);
    setIsRevenueQuarter(false);
    setIsRevenueDay(false);
    setIsRevenueWeek(false);
    setBallroom(true);
    setCulture(false);
    setSelectedReport("");
    setSales(false);
    setReferralType(false);
    setselectedReview("");
    setselectedCallLog("");
    setShowReview(false);
    setRingCentral(true);
    setCountsOnLead(true);
    setShowCallLog(false);
    setSelectedReportName("");
    setSelectedYear("");
    setSelectedMonth(0);
    setSelectedQuarter(0);
    setSelectedWeek(0);
    setSelectedDate("");
    setData([]);
    setError({});
    setmb({});

    // setSelectedReport("");
    // setSelectedDate("");
    // setSelectedWeek("");
    // setSelectedQuarter("");
    // setSelectedMonth("");
    // setSelectedYear("");
    // setData("");
    // setSelectedReportName("");
    // setCalendarValue("0");
    // setCountsOnLead(true);
    // setRingCentral(true);
    // setShowReview(false);
    // setShowCallLog(false);
    // setMatrixvalue("");
    // setReferralType("");
    // setIsRevenueDay(false);
    // setIsRevenueWeek(false);
    // setIsRevenueQuarter(false);
    // setIsRevenueMonth(false);
    // setCalendarValue("");
    // setBallroom(false);
    // setCulture(false);
    // setGeo(false);
    // setReferralType(false);
    // setSales(false);

    dispatch(Reset());
  };

  const clearForm = () => {
    setError({});
    $("#btn-reset").click();
  };

  function filterFunction() {
    if (isRevenueMonth) {
      return selectedMonth;
    } else if (isRevenueQuarter) {
      return selectedQuarter;
    } else if (isRevenueWeek) {
      return selectedWeek;
    } else if (isRevenueDay) {
      return selectedDate
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/\//g, "-");
    } else {
      return "0";
    }
  }

  function buildQueryString(data) {
    const queryString = Object.keys(data)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      )
      .join("&");

    return queryString;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else {
      let Formdata = GetFormData(e);
      Formdata.UserId = sessionUser();
      Formdata.Report = selectedReportName;

      var data = {
        type: isRevenueMonth
          ? "Month"
          : isRevenueQuarter
          ? "Quarterly"
          : isRevenueWeek
          ? "Week"
          : isRevenueDay
          ? "Day"
          : "Year",
        years: selectedYear,
        filter: filterFunction(),
        metrics:
          MatrixValue === 1
            ? "Ballroom"
            : MatrixValue === 2
            ? "Culture"
            : MatrixValue === 3
            ? "Geo"
            : MatrixValue === 4
            ? "Referral"
            : MatrixValue === 5
            ? "Salesperson"
            : "",
        value: "",
      };

      if (selectedReview) {
        data.FeedbackType = selectedReview;
      }

      if (selectedCallLog) {
        data.metrics = selectedCallLog;
      }

      if (mb) {
        data.value = mb;
      }

      const url = buildQueryString(data);
      Formdata.Filters = url;

      await post("Report/InterUpdateFilter", Formdata);
      RefreshKendoGrid("UserSavedFilter");
      $("#save-Filter").modal("hide");
      clearForm();
    }
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const ApplyFilter = (e) => {
    var data = {
      type: isRevenueMonth
        ? "Month"
        : isRevenueQuarter
        ? "Quarterly"
        : isRevenueWeek
        ? "Week"
        : isRevenueDay
        ? "Day"
        : "Year",
      years: selectedYear,
      filter: filterFunction(),
      metrics:
        MatrixValue === 1
          ? "Ballroom"
          : MatrixValue === 2
          ? "Culture"
          : MatrixValue === 3
          ? "Geo"
          : MatrixValue === 4
          ? "Referral"
          : MatrixValue === 5
          ? "Salesperson"
          : "",
      value: "",
    };

    if (selectedReview) {
      data.FeedbackType = selectedReview;
    }

    if (selectedCallLog) {
      data.metrics = selectedCallLog;
    }

    if (mb) {
      data.value = mb;
    }

    const url = buildQueryString(data);
    const controllerActionName =
      selectedReport && selectedReport == 0
        ? ""
        : selectedReport == 1
        ? ""
        : selectedReport == 2
        ? "Report/CountsOnLead_Report?"
        : selectedReport == 3
        ? "Report/Customersatisfication_Report?"
        : selectedReport == 4
        ? "Report/RingCentralSMSLog_Reports?"
        : selectedReport == 5
        ? "Report/RingCentralCallLog_Report?"
        : "";
    const fullUrl = baseURL + controllerActionName + url;
    if (selectedReport == 2) {
      dispatch(UrlForCOL(fullUrl));
    } else if (selectedReport == 3) {
      dispatch(UrlForCS(fullUrl));
    } else if (selectedReport == 4) {
      dispatch(UrlForSMS(fullUrl));
    } else if (selectedReport == 5) {
      dispatch(UrlForCallLog(fullUrl));
    }
    e.preventDefault();
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <form id="form-revenue">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-3">
                    <KendoDropdown
                      name="ReportName"
                      data={ReportList}
                      value={selectedReport}
                      dataTextField={"value"}
                      dataValueField={"id"}
                      onChange={(e) => {
                        return ReportOnChage(e);
                      }}
                      placeholder={"Select"}
                    />
                  </div>
                  {ShowReview && (
                    <div className="col-md-3">
                      <KendoDropdown
                        name="Reviewtype"
                        data={ReviewType}
                        value={selectedReview}
                        dataTextField={"value"}
                        dataValueField={"id"}
                        onChange={ReviewOnChage}
                        placeholder={"Select"}
                      />
                    </div>
                  )}
                  {ShowCallLog && (
                    <div className="col-md-3">
                      <KendoDropdown
                        name="RingCentral"
                        data={CallLogType}
                        value={selectedCallLog}
                        dataTextField={"value"}
                        dataValueField={"id"}
                        onChange={CallLogOnChage}
                        placeholder={"Select"}
                      />
                    </div>
                  )}
                  <div className="col-md-3">
                    <KendoDropdown
                      name="revenueYear"
                      data={revenueYear}
                      value={selectedYear}
                      dataTextField={"text"}
                      dataValueField={"id"}
                      onChange={revenueYearOnChage}
                      placeholder={"Select Year"}
                    />
                  </div>
                  <div className="col-md-3">
                    <KendoDropdown
                      name="revenueCalendar"
                      data={revenueCalendar}
                      value={calendarValue}
                      dataTextField={"value"}
                      dataValueField={"id"}
                      onChange={(e) => revenueCalendarOnChange(e)}
                      placeholder={"Select"}
                    />
                  </div>

                  {!isRevenueDay &&
                  (isRevenueMonth || isRevenueQuarter || isRevenueWeek) ? (
                    <div className="col-md-3" style={{ marginTop: selectedReport == 3 ||  selectedReport == 5 ? "10px" : "0px"  }}>
                      <KendoMultiSelect
                        name="type"
                        data={
                          isRevenueMonth
                            ? months
                            : isRevenueQuarter
                            ? Quarterly
                            : isRevenueWeek
                            ? revenueWeek
                            : []
                        }
                        value={
                          isRevenueMonth
                            ? selectedMonth
                            : isRevenueQuarter
                            ? selectedQuarter
                            : isRevenueWeek
                            ? selectedWeek
                            : undefined
                        }
                        dataTextField={"text"}
                        dataValueField={"id"}
                        onChange={(e) =>
                          typeOnChange(
                            e,
                            isRevenueMonth
                              ? "Month"
                              : isRevenueQuarter
                              ? "Quarterly"
                              : isRevenueWeek
                              ? "Week"
                              : revenueWeek
                          )
                        }
                        tagmode={""}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  {isRevenueDay && (
                    <div className="col-md-3" style={{ marginTop: selectedReport == 3 ? "10px" : "0px"  }}>
                      <KendoDatePicker
                        name={"date"}
                        value={selectedDate}
                        onChange={(e) => {
                          setSelectedDate(e);

                          const date = new Date(e);

                          const formattedDate = date
                            .toLocaleDateString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                            })
                            .replace(/\//g, "-");
                          if (CountsOnLead) {
                            // dispatch(
                            //   getCountOnLeadBarData({
                            //     type:
                            //       calendarValue === 1
                            //         ? "Month"
                            //         : calendarValue === 2
                            //         ? "Quarterly"
                            //         : calendarValue === 3
                            //         ? "Week"
                            //         : calendarValue === 4
                            //         ? "Day"
                            //         : "Year",
                            //     years: selectedYear,
                            //     filter: formattedDate,
                            //     metrics: "",
                            //     value: "",
                            //   })
                            // );
                            // dispatch(
                            //   getCountOnLeadCardsData({
                            //     type:
                            //       calendarValue === 1
                            //         ? "Month"
                            //         : calendarValue === 2
                            //         ? "Quarterly"
                            //         : calendarValue === 3
                            //         ? "Week"
                            //         : calendarValue === 4
                            //         ? "Day"
                            //         : "Year",
                            //     years: selectedYear,
                            //     filter: formattedDate,
                            //     metrics: "",
                            //     value: "",
                            //   })
                            // );
                          } else if (CountsOnLeadReport) {
                            dispatch(
                              getCountsOnLeadReportData({
                                type:
                                  calendarValue === 1
                                    ? "Month"
                                    : calendarValue === 2
                                    ? "Quarterly"
                                    : calendarValue === 3
                                    ? "Week"
                                    : calendarValue === 4
                                    ? "Day"
                                    : "Year",
                                years: selectedYear,
                                filter: formattedDate,
                                metrics: "",
                                value: "",
                              })
                            );
                          } else {
                            dispatch(
                              getRevenuData({
                                type:
                                  calendarValue === 1
                                    ? "Month"
                                    : calendarValue === 2
                                    ? "Quarterly"
                                    : calendarValue === 3
                                    ? "Week"
                                    : calendarValue === 4
                                    ? "Day"
                                    : "Year",
                                years: selectedYear,
                                filter: formattedDate,
                                metrics:
                                  MatrixValue === 1
                                    ? "Ballroom"
                                    : MatrixValue === 2
                                    ? "Culture"
                                    : MatrixValue === 3
                                    ? "Geo"
                                    : "",
                                value: "",
                              })
                            );
                          }
                        }}
                      />
                    </div>
                  )}

                  {CountsOnLead || RingCentral ? (
                    <></>
                  ) : (
                    <div className="col-md-3" style={{ marginTop: "10px" }}>
                      <KendoDropdown
                        name="matrix"
                        data={Matrix}
                        value={MatrixValue}
                        dataTextField={"matrixValue"}
                        dataValueField={"matrixId"}
                        onChange={(e) => {
                          matrixOnChange(e);
                        }}
                        placeholder={"Select"}
                      />
                    </div>
                  )}
                  {shouldnotShowRevenueMatrix ? (
                    <></>
                  ) : (
                    <div className="col-md-3" style={{ marginTop: "10px" }}>
                      <ReportMatrix
                        onChange={updatemb}
                        calendarValue={calendarValue}
                        matrixValue={MatrixValue}
                        selectedYear={selectedYear}
                        filter={
                          isRevenueMonth
                            ? selectedMonth
                            : isRevenueQuarter
                            ? selectedQuarter
                            : isRevenueWeek
                            ? revenueWeek
                            : isRevenueDay
                            ? selectedDate
                            : ""
                        }
                        data={data}
                        placeholder={"Select"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-6 d-flex justify-content-start  mt-2">
                    <Button
                      name={"Save Filter"}
                      styles={{ marginRight: "10px" }}
                      // icon={<i className="las la-angle-down"></i>}
                      onClick={handleSaveClick}
                    />
                  </div>
                  <div className="col-md-6 d-flex justify-content-end  mt-2">
                    <Button
                      styles={{ marginRight: "10px" }}
                      name={"Reset"}
                      onClick={handleResetClick}
                    />
                    <Button
                      styles={{ marginRight: "10px" }}
                      name={"Apply"}
                      onClick={ApplyFilter}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* <!-- Save and Update Filter Modal --> */}
      <div
        className="modal custom-modal fade"
        id="save-Filter"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Save Filter</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-save-filter" onSubmit={onSubmit}>
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="Name"
                      // defaultValue={e}
                      placeholder="Name"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Name", e.target.value);
                      }}
                    />
                    {error.Name && <ErrorMsg text="Name is required" />}
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">
                      Description<span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="Description"
                      // defaultValue={e}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Description", e.target.value);
                      }}
                    />
                    {error.Description && (
                      <ErrorMsg text="Description is required" />
                    )}
                  </div>
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button name={"Save"} />
                  <button
                    type="reset"
                    id="btn-reset"
                    style={{ display: "none" }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Save and Update Filter Modal --> */}
    </>
  );
};

export default ReportDropdown;
